<template>
  <PuSkeletonTheme :duration="0.1" :color="skeletonColor" :highlight="skeletonHighlight">
    <div class="flex items-center">
      <vs-avatar :src="bank.thumbnail" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
      <router-link v-if="bank.name" :to="url" class="text-inherit hover:text-primary" @click.stop.prevent>
        {{ this.bank.name }}
      </router-link>
      <PuSkeleton v-else class="" style="width: 250px; height: 100%"></PuSkeleton>
    </div>
  </PuSkeletonTheme>
</template>

<script>
export default {
  data () {
    return {
      bank: {
        full_name: null,
        thumbnail: 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'
      }
    }
  },
  computed: {
    url () {
      return `/a/testprep/banks/${this.params.value}`
    },
    authorId () {
      return this.params.data.author
    },
    skeletonColor () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(224, 224, 224)'
      if (theme === 'dusk') return 'rgb(5, 0, 53, 1)'
      if (theme === 'dark') return 'rgb(22, 23, 25)'
    },
    skeletonHighlight () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(248, 248, 248)'
      if (theme === 'dusk') return 'rgb(27 25 53)'
      if (theme === 'dark') return 'rgb(94 94 94 / 73%)'
    }
  },
  created () {
    this.$httpCached
      .get(`testprep/banks/${this.params.value}?cc=subscription_table_bank`, {
        ttl: 15
      })
      .then((response) => {
        if (response.data.data) {
          this.bank = response.data.data

          if (this.bank.thumbnail !== null) {
            this.bank.thumbnail = response.data.data.thumbnail
          } else {
            this.bank.thumbnail = 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'
          }
        }
      })
      .catch((exception) => {
        let error = 'An unknown error occurred loading customer details'
        if (exception.response) {
          error = exception.response.data.error.description
        }

        return this.$vs.notify({
          title: 'Failed to author',
          text: error,
          color: 'danger',
          position: 'top-right'
        })
      })
  }
}
</script>
